import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PillHoverState } from '../dashboard-pill-wrapper/pill-hover.directive';

@Injectable({
  providedIn: 'root',
})
export class DashboardPillStateService {
  private readonly pillHoverStateSubject = new Subject<PillHoverState>();
  pillHoverState$ = this.pillHoverStateSubject.asObservable();

  setPillHoverState(state: PillHoverState): void {
    this.pillHoverStateSubject.next(state);
  }
}
